






	import Vue from 'vue';
    import LoginRegisterComp from '../components/einstellungen/LoginRegisterComp.vue';

    export default Vue.extend({
        name: "LoginPage",
        components: {LoginRegisterComp},
        data: () => ({
        })
    })
